<div class="overview-item">
  <span class="title">{{ 'STATISTICS.TOTAL_SURFACE_HEADER' | translate }}</span>
  <div class="d-flex">
    <div class="w-100">
      <span class="amount-value">{{ value }}</span>
      <span class="unit">m<sup>2</sup></span>
    </div>
  </div>
</div>